import { api } from './api';

export interface Cargo {
  id: number;
  descricao: string;
}

export interface CargoRequest {
  id?: number;
  descricao: string;
}

export const cargoService = {
  // Buscar todos os cargos
  getAll: async (): Promise<Cargo[]> => {
    const response = await api.get<Cargo[]>('/api/Cargo/GetAll');
    return response.data;
  },

  // Buscar cargo por ID
  getById: async (id: number): Promise<Cargo> => {
    const response = await api.get<Cargo>(`/api/Cargo/GetById?id=${id}`);
    return response.data;
  },

  // Salvar cargo (criar ou editar)
  save: async (cargo: CargoRequest): Promise<Cargo> => {
    const response = await api.post<Cargo>('/api/Cargo/Salvar', cargo);
    return response.data;
  }
};
